module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"description":"La recherche est effectuée sur l\u0027ensemble des établissements et salariés.","actions.search":"Rechercher un salarié ou un établissement","type.employee":"Salariés","type.institution":"Établissements","employee.archived":"Salarié archivé","institution.archived":"Établissement archivé","no.results":"Aucun résultat","searching":"Recherche en cours"}}')
  delete Component.options._Ctor
}
